export default __webpack_public_path__ + "static/swim-7e28fba71f10ceb92cecd733d6ad0910.webp";